import React, {useState} from "react";
import {toast} from "react-toastify";
import {getFetcher} from "../../../utils/fetcher";
import neverLandUtils from "../../../utils/NeverLandUtils";
import {accountInfo, getImage} from "../../../constants/constants";

const BONA_SEND_PANG_API_TO_USER = "/bonaint/%source%/send_pang_to_target_user_with_usercode";
const BONA_SEND_PANG_API_TO_STORE = "/bonaint/%source%/send_pang_to_target_store_with_storecode";

const PangSendModal = ({closeMatchModal, sendPangInfo}) => {

  const [sendID, setSendID] = useState(sendPangInfo.sendID ?? "");
  const [sendPangAmount, setSendPangAmount] = useState(sendPangInfo.sendPangAmount ?? 0);
  const [isCheckForce, setIsCheckForce] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const closeModal = (isSuccess) => {
    closeMatchModal(isSuccess);
  }

  const editCurrentInfo = () => {
    let _sendID = sendID.trim();
    if (_sendID.length === 0) {
      toast.error("선물 받을 대상의 ID를 확인/입력해주세요");
      return;
    }
    let _amount = Number(sendPangAmount);
    if (sendPangAmount.length <= 0) {
      toast.error("선물할 팡이 너무 적습니다.");
      return;
    }
    // if(sendPangInfo.currentPang<_amount) {
    //     toast.error("선물할 팡이 보유팡 보다 많습니다.(부족한 팡:"+(_amount-sendPangInfo.currentPang).toLocaleString()+")");
    //     return;
    // }

    let currentAPI = "";
    let params = {
      user: accountInfo.makeJson(),
      sendPangAmount: _amount,
      cause: sendPangInfo.cause ?? "팡 선물",
      securityKey: "yessuar0x883172aa"
    };
    if (sendPangInfo.targetType === 'user') {
      currentAPI = BONA_SEND_PANG_API_TO_USER;
      params.targetUserCode = _sendID;
    }
    if (sendPangInfo.targetType === 'store') {
      currentAPI = BONA_SEND_PANG_API_TO_STORE;
      params.targetStoreCode = _sendID;
    }

    currentAPI = currentAPI.replace("%source%", sendPangInfo.sourceType);
    if (currentAPI.length === 0)
      return;
    getFetcher().post(currentAPI, params, {
      headers: {
        "Content-type": "application/json"
      }
    }).then(res => {
      console.log(res);
      const {header, result} = res.data;
      if (header.type === 'success') {
        toast.success(header.message);
        closeModal(true);
      } else if (header.type === 'fail') {
        toast.error(header.message);
        closeModal(false);
      } else toast.warning(header.message);
    }).catch(err =>
        toast.error(err.message));
  }

  let _sendPangInfo = sendPangInfo;


  return (
      <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
        {isLoading && (
            <div
                className="w-full h-screen flex flex-col justify-center items-center fixed top-0 left-0 overflow-hidden z-60 bg-white bg-opacity-70">
              <img src={getImage('loadingImage')} alt="loadingImage" className="h-32 w-auto"/>
              <span className="font-bold text-sky-700"> 팡 선물하는중... </span>
            </div>
        )}

        <div className="bg-white rounded-lg shadow-lg p-6 w-96">
          <h2 className="text-xl font-semibold mb-1">보유 팡 내역</h2>
          <div className="text-sm font-medium text-gray-600">선물할 팡과 선물할 ID를 입력해주세요</div>

          <div className="mt-5 flex flex-col">
            <p className="text-sm">보유한 팡</p>
            <input
                value={_sendPangInfo.currentPang.toLocaleString()}
                disabled={true}
                className="mt-1 px-4 w-full font-semibold rounded-md border-0 py-1.5 pl-2 bg-gray-200 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
            />
          </div>

          <div className="mt-5 flex flex-col">
            <p className="text-sm">선물할 팡</p>
            <input
                value={isCheckForce ? sendPangAmount : sendPangAmount.toLocaleString()}
                onFocus={(e) => {
                  e.target.value = sendPangAmount;
                  setSendPangAmount(sendPangAmount)
                  setIsCheckForce(true);
                }}
                onBlur={(e) => {
                  e.target.value = sendPangAmount.toLocaleString();
                  setSendPangAmount(sendPangAmount)
                  setIsCheckForce(false);
                }}
                onChange={(e) => {
                  let newValue = neverLandUtils.utils.textToNumber(e.target.value);
                  setSendPangAmount(newValue);
                }}
                className="mt-1 px-4 w-full font-semibold rounded-md border-0 py-1.5 pl-2 bg-white text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
            />
          </div>

          <div className="mt-5 flex flex-col">
            <p className="text-sm">선물할 ID</p>
            <input
                value={sendID}
                onChange={(e) => setSendID(e.target.value)}
                className="mt-1 px-4 w-full font-semibold rounded-md border-0 py-1.5 pl-2 bg-white text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
            />
          </div>

          <div className="mt-5 flex flex-row justify-center sm:mt-6 grid-cols-2 gap-3">
            <button
                onClick={() => {
                  setIsLoading(true);
                  editCurrentInfo();
                  setTimeout(() => {
                    setIsLoading(false);
                  }, 3000); // 3초 동안 로딩
                }}
                type="button"
                className={neverLandUtils.classNames(isLoading ? "hidden" : "", "w-24 justify-center rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm sm:col-start-2")}
            >
              보내기
            </button>
            <button
                type="button"
                className="w-24 justify-center rounded-md bg-rose-600 px-3 py-2 text-sm font-semibold text-white shadow-sm sm:col-start-1 sm:mt-0"
                onClick={closeModal}
            >
              취소
            </button>
          </div>
        </div>
      </div>
  );
}
export default PangSendModal;